import { createApp } from 'vue'
import NoteList from'../components/notes/NoteList.vue';

if (document.getElementById('participant-notes')) {
  const participantNotes = createApp({})
  participantNotes.component('NoteList', NoteList)
  participantNotes.mount('#participant-notes')
}